/* ==========================================================================
   SelectPanel > Helpers
   ========================================================================== */
function isValid(data) {
    return data !== null && data !== undefined;
}

function flattenSelectOptions(data) {
    return data.map(item => item.choices || []).reduce((prev, curr) => prev.concat(curr));
}

function getChoiceByDeafult(data) {
    const { value, items: selectOptions = [{ label: ' ' }] } = data;
    const hasGroups = selectOptions.some(item => item.choices);

    const items = hasGroups ? flattenSelectOptions(selectOptions) : selectOptions;

    return isValid(value)
        ? items.filter(item => item.value === value)[0] || {}
        : items.filter(item => item.selected)[0] || {};
}

function getChoiceValue(data) {
    const { value } = getChoiceByDeafult(data) || {};

    return value;
}

function getUpdatedChoices(data) {
    const { items = [], value } = data;

    const hasGroups = items.some(item => item.choices);

    return hasGroups
        ? items.map(item => {
              const { choices = [] } = item;
              return {
                  ...item,
                  choices: choices.map(choice => ({ ...choice, selected: choice.value === value }))
              };
          })
        : items.map(choice => ({ ...choice, selected: choice.value === value }));
}

module.exports = {
    getChoiceByDeafult,
    getChoiceValue,
    getUpdatedChoices
};
